/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import type {ChangeEvent, MouseEvent} from "react";

export function TableCheckbox({
    checked,
    indeterminate,
    onChange,
    onClick,
}: {
    checked: boolean
    indeterminate?: boolean
    onChange: (event: ChangeEvent<HTMLInputElement>) => void
    onClick?: (event: MouseEvent<HTMLInputElement>) => void
}) {
    return (
        <input
            type="checkbox"
            className="table-checkbox"
            checked={checked}
            ref={(el) => {
                if (el) {el.indeterminate = Boolean(indeterminate);}
            }}
            onChange={onChange}
            onClick={onClick}
        />
    );
}
